import { render } from "./FooterSmall.vue?vue&type=template&id=a1d2cb96"
import script from "./FooterSmall.vue?vue&type=script&lang=js"
export * from "./FooterSmall.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Footers/FooterSmall.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a1d2cb96"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a1d2cb96', __exports__)) {
    api.reload('a1d2cb96', __exports__)
  }
  
  module.hot.accept("./FooterSmall.vue?vue&type=template&id=a1d2cb96", () => {
    api.rerender('a1d2cb96', render)
  })

}


export default __exports__